
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.016.993a.917.917 0 00-.917.917v.764A10.83 10.83 0 0010.943 0C4.909 0 0 4.927 0 10.982a.917.917 0 001.833 0c0-5.045 4.087-9.149 9.11-9.149 2.203 0 4.273.78 5.904 2.182h-.84a.917.917 0 000 1.833h3.009c.506 0 .917-.41.917-.917V1.91a.917.917 0 00-.917-.917zM21.083 10.102a.917.917 0 00-.916.916c0 5.045-4.087 9.149-9.11 9.149a9.016 9.016 0 01-5.848-2.132h.88a.917.917 0 000-1.833H3.082l-.024.002a.894.894 0 00-.104.01c-.025.005-.051.007-.076.013-.03.007-.06.018-.09.028-.028.01-.056.018-.082.03-.025.01-.05.026-.073.04-.03.016-.058.032-.085.051l-.021.013c-.016.012-.028.027-.042.04a.846.846 0 00-.222.285.835.835 0 00-.063.166c-.007.028-.015.056-.02.085a1.003 1.003 0 00-.01.098c0 .018-.005.037-.005.056v3.021a.917.917 0 001.833 0v-.728A10.835 10.835 0 0011.057 22C17.091 22 22 17.073 22 11.018a.917.917 0 00-.917-.916z"}})])
          )
        }
      }
    